(function () {
    'use strict';

    angular
        .module('oddQuestionnaireTemplateModule')
        .controller('oddQuestionnaireTemplateStaticTextFullController', Controller);

    Controller.$inject = ['$scope', '$timeout', '$state', 'govNotificationDelay'];

    function Controller($scope, $timeout, $state, govNotificationDelay) {

        $scope.ctrlCtxt = {};

        // showIsInCampaignErrorMsg
        $scope.showIsInCampaignErrorMsg = function () {
            $scope.ctrlCtxt.isInCampaignMsgShow = true;

            $timeout(function () {
                $scope.ctrlCtxt.isInCampaignMsgShow = false;
            }, govNotificationDelay);
        };

        // Discard Changes
        $scope.discardChanges = function () {
            $state.reload();
        };

        // Cancel
        $scope.cancel = function () {
            $state.go('^', { reload: true });
        };
    }

})();